import React, { useEffect, useState } from "react";
import context from "lib/stores/context";
import { warn } from "console";

export const useResizeListener = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
      if (window.innerWidth >= 0 && window.innerWidth <= 1023) {
        // const sidebarHeight = document.getElementById("sidebar-header").clientHeight;
        // document.getElementById("deckgl-wrapper").style.height = `${window.innerHeight - sidebarHeight}px`;
      } else {
        context.panelOpen = true;
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [window.innerWidth]);
};
